import { render, staticRenderFns } from "./PanelCompetitionSettingLayout.vue?vue&type=template&id=89c99352&scoped=true&"
import script from "./PanelCompetitionSettingLayout.vue?vue&type=script&lang=js&"
export * from "./PanelCompetitionSettingLayout.vue?vue&type=script&lang=js&"
import style0 from "@melloware/coloris/dist/coloris.css?vue&type=style&index=0&prod&lang=css&"
import style1 from "./PanelCompetitionSettingLayout.vue?vue&type=style&index=1&id=89c99352&prod&lang=css&"
import style2 from "./PanelCompetitionSettingLayout.vue?vue&type=style&index=2&id=89c99352&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89c99352",
  null
  
)

export default component.exports